import { action_types, ToolbarModel } from './model'

export default function handler(state = new ToolbarModel(), actions) {
    return state;
}